import { render, staticRenderFns } from "./loadMore2.vue?vue&type=template&id=803146fc&scoped=true&"
import script from "./loadMore2.vue?vue&type=script&lang=js&"
export * from "./loadMore2.vue?vue&type=script&lang=js&"
import style0 from "./loadMore2.vue?vue&type=style&index=0&id=803146fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803146fc",
  null
  
)

export default component.exports